export enum LoginType {
  Email = "email",
  Google = "google",
  Microsoft = "microsoft",
  Saml = "saml",
}
